const backend_url = 'https://2c4c-167-99-227-246.ngrok.io'

$(document).ready(() => {
  const buildYour12_url = 'https://keepyourcadence.com/products/build-your-12'
  const isBuildBundle = true;
  const bundleSize = 6;
  const colorType = "color-option";
  const labelType = "label-value";
  const colorNames = ['Charcoal', 'Petal', 'Lavender', 'Sand', 'Terracotta', 'Pacific', 'Arctic', 'Atlantic', 'Pine', 'Sage', 'Eucalyptus', '5PM', '6PM', '7PM'];
  const labelColors = ['white', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'white', 'black', 'black'];
  const labelColorsByColor = {
    Charcoal: 'white',
    Petal: 'black',
    Lavender: 'black',
    Sand: 'black',
    Terracotta: 'black',
    Arctic: 'black',
    Pacific: 'black',
    Atlantic: 'black',
    Pine: 'white',
    Sage: 'black',
    Eucalyptus: 'black',
    "5PM": 'black',
    "6PM": 'black',
    "7PM": 'black',
  };
  window.outOfStockAraki = {
    "Charcoal":   ['araki-drop-icon', 'araki-eye-icon', 'araki-hearts-icon', 'araki-mushroom-icon', 'araki-rings-icon', 'araki-sun-icon'],
    "Petal":      [                   'araki-eye-icon', 'araki-hearts-icon',                        'araki-rings-icon'],
    "Lavender":   [                   'araki-eye-icon',                                             'araki-rings-icon'],
    "Sand":       ['araki-drop-icon', 'araki-eye-icon', 'araki-hearts-icon', 'araki-mushroom-icon', 'araki-rings-icon', 'araki-sun-icon'],
    "Terracotta": [                   'araki-eye-icon',                      'araki-mushroom-icon', 'araki-rings-icon', 'araki-sun-icon'],
    "Pacific":    [                   'araki-eye-icon',                                             'araki-rings-icon'],
    "Eucalyptus": [                   'araki-eye-icon',                                             'araki-rings-icon', 'araki-sun-icon'],
    "5PM": arakiIcons,
    "6PM": arakiIcons,
    "7PM": arakiIcons,
  };
  
  let productVariants = []
  $.get(`/products/build-your-6.json`, function( data ) {
    productVariants = data.product.variants
    const sel = $('<select class="hidden-mobile hidden-desktop main-variant-select">');
    $(productVariants).each(function() {
      sel.append($("<option>").attr('value',this.id).text(this.title));
    });
    $('.buy-wrapper').append(sel)
  });

  $('.product-footer .counter .plus').click((el) => {
    const input = $(el.target).closest('.counter').find('input')
    const value = Number(input.val())
    input.val(value + 1)
  })

  $('.product-footer .counter .minus').click((el) => {
    const input = $(el.target).closest('.counter').find('input')
    const value = Number(input.val())
    input.val(value <= 1 ? 1 : value - 1)
  })
  
  
  const labelArray = [...Array(bundleSize).keys()].map(elem => `<span class="label-${elem+1}"></span>`).join('');
  const labelsMain = `<div class="build-your-${bundleSize}-labels-main">${labelArray}</div>`;
  $($('.product-image-main')[0]).append(labelsMain);

  new Swiper('.swiper.swiper-product', {
    direction: 'horizontal',
    noSwipingSelector:'.label-inner',
    loop: false,
  
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    hashNavigation: {
      watchState: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next-product',
      prevEl: '.swiper-button-prev-product',
    },
  });

  Selectize.define('araki-icons', function (options) {
    const self = this;
    const setup = self.setup;
    const open = self.open;
    this.setup = function () {
      setup.apply(self, arguments);
      // Intercept default handlers
      self.$dropdown.off('mousedown click', '[data-selectable]').on('mousedown', '[data-selectable]', function (e) {
        if ($(this).data('value') !== 'label_araki') {return self.onOptionSelect.apply(self, arguments);}
        self.$dropdown.find('.is_author').toggle();
        $(this).find('.arrow').toggleClass('ico-chevron-up').toggleClass('ico-chevron-down');
        return false;
      });
    }
    this.open = () => {
      self.$dropdown.find('.is_author').hide();
      self.$dropdown.find('[data-value="label_araki"] .arrow').removeClass('ico-chevron-up').addClass('ico-chevron-down');
      open.apply(self, arguments);
    }
  });

  $('select[data-build-selectize]').each(function () {
    const that = $(this);
    if (that.data('type') === 'color-option') handleColor();

    const plugins = ['restore_on_backspace', 'araki-icons'];

    $(this).selectize({
      plugins: ['araki-icons', starterLabelSelectizeBaSPlugin],
      delimiter: ',',
      persist: false,
      create: false,
      form: 'test',
      sortField: [{
        field: 'name',
        direction: 'asc'
      }],
      searchField: ['value'],
      maxItems: 1,
      hideSelected: false,
      openOnFocus: true,
      create: function(input) {
        return {
          value: input,
          text: input,
          className: starterLabelSelectizeUserCreatedTagClass
        }
      },
      onInitialize: function() {
        if (this.$input.data('type') !== labelType) this.$control_input.prop('readonly','readonly');
        this.$control_input.parent().addClass('selectize-search-icon');
      },
      onClear: function() {
          $('.selected-items-list').empty();
          setMainImgLabels(this.$input, '')
      },
      onChange: function (value) {
        const elem = this.$input[0];
        const selectedOption = $(elem).find('option:selected').val();
        const select = $(elem).closest('select');

        if (select.data('type') === colorType) {
          $(elem).closest('.label-block').find('.custom-color-container').hide()
          const productIndex = select.data('product-index');
          const values = Object.keys($(this)[0].options);
          const index = values.indexOf(selectedOption);
          const colorIdx = colorNames.indexOf(selectedOption.trim());
          const color = labelColors[colorIdx];
          this.prevColor = value

          // label img
          $(`.hex-container-${productIndex}`).find('.product-label-image').removeClass('active');
          $($(`.hex-container-${productIndex}`).find('.product-label-image')[colorIdx]).addClass('active');
          // label text color
          $(`.hex-container-${productIndex}`).find('.hex-graphics text').css('fill', color);
          // bundle overlay capsules
          const imagesArray = $('.imageFromService').attr('data-boxes').split(',');
          imagesArray[productIndex - 1] = index + 1;
          $('.imageFromService').attr('data-boxes', imagesArray.join(','))
          $('.imageFromService').attr('src', `${image_service_url}/api/image?type=build&capsules=${imagesArray.join(',')}&device=desktop&source=landing-products`)
        }

        if (select.data('type') === labelType && value) {
          const labelParent = this.$input.closest('.label-block ');
          $('[data-selected-label]').each(function () {
            $(this).html(`${$(this).attr('data-label-prefix') || 'Label'}: ${value}`);
          });
          labelParent.data('prev-value', value)
        }

        const labelSelectize = $(elem).closest('.label-block').find('.premade-labels [data-build-selectize]').eq(0)
        const label = $(elem).closest('.label-block').find('.premade-labels .item').attr('data-value') || ''
        const color = $(elem).closest('.label-block').find('.color-dropdown .item').attr('data-value') || $('.color-options .variant-input.active input').val() || ''
        if (window.outOfStockAraki[color] && 
          label.length > 0 && 
          window.outOfStockAraki[color].includes(label)
        ) {
          const selectize = labelSelectize.data('selectize');
          $(elem).closest('.label-block').data('prev-value', '')
          
          selectize.clear()
          selectize.setValue("");
          callPreOrderModal(
            $(this).data('product-name'),
            $(this).data('product-id'),
            $(this).data('variant-name'),
            $(this).data('variant-id'),
            'araki-'
          );
        }
        _updateLabels();
        updateByButton();
      },
      render: {
        option: function (data, escape) {
          let additionalClass = (() => {
            if (data.value === 'label_free') return ' custom-selectize-label'
            if (data.value.includes('Custom Logo')) return ' custom-logo-label'
            return ''
          })();
          if (data.disabled) additionalClass += ' disabled';
          let div1 = `<div class="option${additionalClass} ${data.is_author ? 'is_author' : ''}"  data-selectable="" data-customize="${data.customize}" data-value="${data.value}">`;
          if (data.value === 'label_araki') {
            return `${div1}<span>${data.text}</span><span class="arrow ico-chevron-down"></span></div>`
          }
          if (data.type === colorType) {
            div1 =`<div style="display: flex; align-items: center" class="option${additionalClass} color${data.value}" data-product-id="${data.productId}" data-product-name="${data.productName}" data-variant-id="${data.variantId}" data-variant-name="${data.variantName}"  data-selectable="" data-customize="${data.customize}" data-value="${data.value}">`;
            // Colors also have asset `url`s — must not fall through to icon <img> render.
            if (isGoldenHour(data.value)) {
              return `${div1}<span class="color-option color-swatch--${data.value.toLowerCase()}"></span>${data.value}</div>`;
            }
            return `${div1}<span class="color-option ${data.value}"></span>${data.value}</div>`;
          }
          if (isIcon(data.value) || data.url) {
            return `${div1}<img src="${window.getSelectizeIconUrl?.(data) || data.url || ''}" style="width: 1.5rem;"></div>`;
          }
          return `${div1}${data.text}</div>`;
        },
        item: function (data, escape) {
          let div1 = `<div class="item ${escape(data.className)}" data-labelmessage="${data.text}" data-value="${data.value}">`;
          if (data.type === colorType) {
            div1 = `<div style="display: inline-flex; align-items: center" class="item" data-labelmessage="${data.text}" data-value="${data.value}">`;
            return `${div1}<span class="color-option ${data.value} _${data.value}"></span>${data.value}</div>`;
          }
          if (isIcon(data.value) || data.url) {
            return `${div1}<img src="${window.getSelectizeIconUrl?.(data) || data.url || ''}" style="width: 1.5rem; margin-left:1.5rem;"></div>`;
          }
          return `${div1}${data.value}</div>`;
        },
        ...selectizeHelper.render
      },
      onItemAdd: function (value, $item) {
        $item.addClass('selected');
        this.settings.setPlaceholder(this)
      },
      onItemRemove: function(value){
        const $selectedItemsList = $('.selected-items-list');
        const $selectedItem = $selectedItemsList.find(`.selected-item[data-value="${value}"]`);
        if ($selectedItem.hasClass(starterLabelSelectizeUserCreatedTagClass)) {
          this.removeOption(value)
          this.$dropdown.find(`[data-value="${value}"]`).remove()
        }
        this.$control_input.prop('readonly', true)
        this.settings.setPlaceholder(this)
      },
      createFilter: function(input) {
        const regexp = new RegExp('^' + input, 'i');
        return (item) => regexp.test(item.text);
      },
      onFocus: function() {
        if (this.$input.data('type') !== labelType) {
          const input = 'selectize-input input', wrapper = 'selectize-input';
          $(`.${input}`).attr('readonly', true);
          $(`.${input}, .${wrapper}`).css('cursor', 'pointer');
        }
      },
      onDropdownOpen: function() {
        if (this.$input.data('type') === labelType) {
          this.clear()
          this.$control_input
            .focus()
            .blur()
            .prop('readonly', true)
            .on('mousedown', function() {
              $(this).prop('readonly', false);
            })
            .attr('maxlength', maxCustomLabelLength);
          this.settings.setPlaceholder(this)
          $('.selectize-dropdown').addClass('open')
        }
      },
      onDropdownClose: function() {
        this.settings.setPlaceholder(this)
      },
      setPlaceholder: function(self) {
        const dropDownIsOpen = self.$dropdown.is(":visible")
        const placeholder = dropDownIsOpen ? placeholderOnLebelSelectizeOpen : self.settings.placeholder
  
        self.$control_input.attr('placeholder', placeholder);
      },
      onBlur: function() {
        const labelParent = this.$input.closest('.label-block ');
        const value = labelParent.data('prev-value')
        if(this.$input.data('type') === labelType && !this.items.length && value) {
          const valueToSet = this.search(value).items[0].id
          this.setValue(valueToSet)
        }
        this.settings.setPlaceholder(this) 
        $('.selectize-dropdown').removeClass('open')
      }
    });

    function handleColor() {
      const selectedOption = that.find('option:selected').val();
      const productIndex = that.data('product-index');
      const values = Array.from(that[0].options).map(o => o.value);
      const index = values.indexOf(selectedOption);
      const colorIdx = colorNames.indexOf(selectedOption.trim());
      const color = labelColors[colorIdx];

      // label img
      $(`.hex-container-${productIndex}`).find('.product-label-image').removeClass('active');
      $($(`.hex-container-${productIndex}`).find('.product-label-image')[colorIdx]).addClass('active');
      // label text color
      $(`.hex-container-${productIndex}`).find('.hex-graphics text').css('fill', color);
      // bundle overlay capsules
      if (isBuildBundle) {
        $(`.build-your-${bundleSize}-overlay-image.i${productIndex}`).removeClass('active');
        $(`.build-your-${bundleSize}-overlay-image.i${productIndex}.c${index + 1}`).addClass('active');
      }

      _updateLabels();
    }
  });

  function callPreOrderModal(productName, productId, variantName, variantId, modalPrefix = '') {
    $(`#${modalPrefix}pre-order-modal`).data({ productId, variantId })
    $('.pre-order-product-name').html(productName);
    $('.pre-order-variant-name').html(variantName);
    $(`#${modalPrefix}pre-order-modal`).modal();
  }

  function _updateLabels() {
    let elem = null;
    if(isBuildBundle) {
      for (let i = 1; i <= bundleSize; i++) {
        elem = $(`.premade-labels select[name="properties[Standard Bundle Label ${i}]"]`);
        if (elem.length) {
          _updateLabel(elem);
        }
      }
    } else {
      elem = $('.premade-labels select[name="properties[Label]"]');
      if (elem.length > 0) _updateLabel(elem);
    }
  }
  function _updateLabel(elem) {
    const selectedOption = elem.find('option:selected').val();
    let selectValue = null;
    if (selectedOption === 'customize') {
      elem.closest(".label-block").find('.custom-labels').show()
    }else {
      elem.closest(".label-block").find('.custom-labels').hide()
    }
    if(!isCustomize(selectedOption) || isArakiIcon(selectedOption)) {
      getPremadeLabel(elem);
      selectValue = 'standard';
    } else {
      clearPremadeLabel(elem);
      const labelParent = $(elem).closest('.label-block ');
      $('.custom-label',labelParent).trigger('input');
      selectValue = 'custom';
    }
    if (isArakiIcon(selectedOption)) {
      selectValue = 'custom';
    }
    $('.main-variant-select option').removeAttr('selected');
    $(`.main-variant-select option:contains('${calcBundleVariant()}')`).attr('selected', true);
    updatePrice()
  }


  function getLabelColor(elem) {
    // Get active color index and label color
    var color = labelColors[0];
    if (isBuildBundle){
      const labelBlock = elem.closest('.label-block.single-type');
      const selectedColor = labelBlock
        .find('select[data-type="color-option"]')
        .find('option:selected')
        .val();
      color = labelColorsByColor[selectedColor];
    } else {
      const colorLabel = $('.color-options label.color-swatch.active');
      const selectedColor = colorLabel.text().trim();
      color = labelColorsByColor[selectedColor];
    }
    return color;
  }

  function getPremadeLabel(input) {
    const labelDest = $(input).data('location');
    const label = $(input).val()?.trim();
    const hex = $(input).closest('.label-container').data('hex');
    const selector = $(`#${hex} text.${labelDest}`);
    const color = getLabelColor(input);

    // Reset canvas
    $(`#${hex} image`).attr('opacity','0.0');
    $(selector).html('');

    // Render text or icon
    const opacity = isArakiIcon(label) ? "1" : "0.5"
    if (isIcon(label)) {
      const hexImage = $(`#${hex} image#${label}-${color}`);
      if (hexImage.length) {
        hexImage.attr('opacity', opacity);
      } else {
        const iconUrl = window.getIconUrlForLabel?.(label, input);
        const dynamicImg = $(`#${hex} image#metaobject-icon-${color}`);
        if (iconUrl && dynamicImg.length) {
          dynamicImg.attr('href', iconUrl).attr('xlink:href', iconUrl).attr('opacity', opacity);
        }
      }
    } else $(selector).html(parseLabel(label));

    setMainImgLabels(input, label);
  }

  function getCustomLabel(input, val) {
    const labelDest = $(input).data('location');
    const label = val || $(input).val();
    const hex = $(input).closest('.custom-label-container').data('hex');
    const selector = $('#' + hex + ' text.' + labelDest + '');

    // Reset canvas
    $(`#${hex} image`).attr('opacity','0.0');
    $(selector).html('');

    // Render text
    $(selector).html(parseLabel(label));
    setMainImgLabels($(input), label);
  }

  // Update main gallery preview
  function setMainImgLabels(elem, label) {
    console.log('setMainImgLabels', elem, label);
    if (!isBuildBundle && !isLabel) return;

    const color = getLabelColor(elem);
    let spanSelector = $(`.extra-label-labels-main > span.label`)
    if(isBuildBundle) {
      const curBlock = $(elem).closest('.label-block');
      const index = $('.label-block').index(curBlock) + 1;
      const parsedLabel = parseLabel(label);
      spanSelector = `.build-your-${bundleSize}-labels-main > span.label-${index}`;
    }
    const span = $(spanSelector)

    if (isIcon(label)) {
      span.html('');
      let imgSrc = window.getIconUrlForLabel?.(label, elem);
      if (!imgSrc) {
        const clonedImg = $($(`div.option[data-value="${label}"] > img`)[0]);
        imgSrc = clonedImg.attr('src');
      }
      if (imgSrc) {
        imgSrc = window.colorizeIconUrl?.(imgSrc, color) || imgSrc;
        const img = $('<img>').attr('src', imgSrc).attr('id', label);
        if (isArakiIcon(label)) {
          img.addClass('araki');
          span.addClass('araki')
        }
        img.appendTo(span);
      }
    } else {
      span.removeClass('araki')
      span.html(parseLabel(label));
      span.css('color', color);
    }
  }

  $('.custom-label').on('input', function () {
    // source: https://stackoverflow.com/a/45138005
    const emoticonsRegexp = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/ug;
    const validatedValue = this.value.replace(emoticonsRegexp, "");
    $(this).val(validatedValue);
    const labelParent = $(this).closest('.label-block ');
    labelParent.data('custom-prev-value', validatedValue)
    getCustomLabel(this, validatedValue);
    updateByButton()
  });

  $('.custom-label').each(function () {
    getCustomLabel(this);
  });

  function calcBundleVariant() {
    const customLabelsCount = $('.premade-labels div.selectize-input > div.item').filter((index, item) => {
      return isCustomize(item);
    }).length;
    if (customLabelsCount === 0) return `${bundleSize} standard`;
    if (customLabelsCount === bundleSize) return `${bundleSize} custom`;
    return `${customLabelsCount} custom & ${bundleSize - customLabelsCount} standard`;
  }
  function clearPremadeLabel(input) {
    var labelDest = $(input).data('location');
    var hex = $(input).closest('.label-container').data('hex');
    var selector = $('#' + hex + ' text.' + labelDest + '');
    $(selector).text('');
  }

  function updatePrice() {
    const variant_id =  $('.main-variant-select').val()
    const variant = productVariants.find((el) => el.id === Number(variant_id))
    if (!variant) return

    $('.buy-button .price').text(`$${variant.price}`.replace('.00', ''))
    $('.buy-button .old-price').text(`$${variant.compare_at_price}`.replace('.00', ''))
  }

  $('.buy-button').click(async () => {
    const byButton = $('.buy-button')
    if (byButton.hasClass('disabled')) return $('.js-modal-open-info-msg-modal').click()

    byButton.html('Loading...')
    const properties = {}
    $('.label-block').each((i, el) => {
      const color = $(el).find('[data-type="color-option"]').val()
      const label = $(el).find('.premade-labels .item').data('value')
      const customLabel = $(el).find('.custom-label').val()
      properties[`Bundle Color ${i + 1}`] = color
      properties[`Standard Bundle Label ${i + 1}`] = label
      properties[`Custom Bundle Label ${i + 1}`] = customLabel
    })
    const mainData = {
      items : [
        {
          id: $('.main-variant-select').val(),
          quantity: $('.product-footer input').val(),
          properties: properties
        }
      ]
    }
    addShadowProducts(mainData)

    await $.post('/cart/clear.js')
    $.post('/cart/add.js', mainData).then(() => {
      window.location.href = '/checkout';
    })
  })

  function addShadowProducts(data) {
    const $container = $('.build-your-right')
    const hashName = $('[data-cpsl_cnt]', $container).attr('data-hash_name')
    const count = bundleSize
    const { items } = data
    const product = items[0]
    product.properties ||= {}
    product.properties['Timestamp'] = new Date().getTime()
    for (let i = 1; i <= count; i++) {
      properties = {
        'Product': hashName,
        'Color': product.properties[`Bundle Color ${i}`],
        'Label': product.properties[`Standard Bundle Label ${i}`],
        'Custom Label': product.properties[`Custom Bundle Label ${i}`],
        'Parent Timestamp': product.properties['Timestamp']
      }
      const shadowProductId = getShadowProduct('capsule', properties['Color'], defaulf_size.toLowerCase())?.id
      const item = {id: shadowProductId, quantity: Number(product.quantity), properties}
      const existingItem = existingShadowProductItem(item, items)
      if (existingItem)
        existingItem.quantity += Number(product.quantity)
      else 
        items.push(item)
    }
    items.forEach((el) => el.properties && el.properties['Parent Timestamp'] === product.properties['Timestamp'] && (el.properties['Quantity'] = el.quantity / product.quantity))
  }

  $('.go-to-build-your-12').click(() => {
    let url = `${buildYour12_url}?`
    $('.label-block').each((i, el) => {
      const color = $(el).find('[data-type="color-option"]').val()
      const label = $(el).find('.premade-labels .item').data('value')
      const customLabel = $(el).find('.custom-label').val()
      url += `&color${i}=${color || ''}`
      url += `&label${i}=${label || ''}`
      url += `&customLabel${i}=${customLabel || ''}`
    })
    window.location.href = url;
  })

  function updateByButton() {
    let isActive = true
    $('.label-block').each((i, el) => {
      const color = $(el).find('[data-type="color-option"]').val()
      const label = $(el).find('.premade-labels .item').data('value')
      const customLabel = $(el).find('.custom-label').val()
      if (label === 'customize' && !customLabel) isActive = false
      if (!color || !label) isActive = false
    })
    $('.buy-button').addClass('disabled')
    if (isActive) 
      $('.buy-button').removeClass('disabled')
  }

  $('.drawer__close-button').click(() => {
    $('#CartDrawer').removeClass('drawer--is-open')
  })
})